import React from "react";
import { FaAlignJustify } from "react-icons/fa";

export type ContentType = "words" | "phrases";

interface WordsPhrasesTabsProps {
  value: ContentType;
  onChange: (value: ContentType) => void;
}

const ACTIVE = "#2A2A3D";
const INACTIVE = "var(--color-grey)";

/**
 * WordsPhrasesTabs — PWA port of client-native WordsPhrasesTabs.tsx.
 * Two tabs sharing one sliding 3px underline. Words tab uses a literal serif
 * "T" glyph (Georgia, matching iOS); Phrases tab uses a reorder-style icon.
 */
const WordsPhrasesTabs: React.FC<WordsPhrasesTabsProps> = ({
  value,
  onChange,
}) => {
  const isWords = value === "words";
  return (
    <div className="relative w-full select-none">
      <div className="flex w-full">
        <button
          onClick={() => onChange("words")}
          className="flex-1 flex items-center justify-center gap-1.5 py-3"
          style={{ color: isWords ? ACTIVE : INACTIVE }}
        >
          <span
            style={{ fontFamily: "Georgia, serif", fontSize: 20, fontWeight: 700 }}
          >
            T
          </span>
          <span className="text-lg font-semibold">Words</span>
        </button>
        <button
          onClick={() => onChange("phrases")}
          className="flex-1 flex items-center justify-center gap-1.5 py-3"
          style={{ color: !isWords ? ACTIVE : INACTIVE }}
        >
          <FaAlignJustify size={18} />
          <span className="text-lg font-semibold">Phrases</span>
        </button>
      </div>

      {/* Sliding underline */}
      <div
        className="absolute bottom-0 h-[3px] transition-all duration-200 ease-in-out"
        style={{
          width: "50%",
          left: isWords ? "0%" : "50%",
          backgroundColor: ACTIVE,
          borderRadius: 1.5,
        }}
      />
    </div>
  );
};

export default WordsPhrasesTabs;
